// src/context/CurrencyContext.js
import React, { createContext, useState, useEffect } from "react";
import { db } from "../firebase-config";
import { doc, onSnapshot } from "firebase/firestore";

export const CurrencyContext = createContext();

export const SURCHARGE_EUR = 0;

export function pricePlusSurcharge(priceEUR, cur, fx) {
  const grossEUR = priceEUR + SURCHARGE_EUR;

  // Calculate in XAF
  const xaf = grossEUR * (fx.XAF || 655.957);

  // Round up to nearest 100 XAF
  const roundedXAF = Math.ceil(xaf / 100) * 100;

  return {
    numeric: roundedXAF,
    formatted: `${roundedXAF.toLocaleString()} XAF`,
  };
}

export const CurrencyProvider = ({ children }) => {
  const [currency] = useState("XAF"); // Fixed to XAF only

  const [exchangeRates, setExchangeRates] = useState({
    XAF: 655.957, // Default: 1 EUR = 655.957 XAF
  });

  useEffect(() => {
    const ratesDocRef = doc(db, "FX", "rates");

    const unsubscribe = onSnapshot(
      ratesDocRef,
      (snap) => {
        if (snap.exists()) {
          const d = snap.data();
          setExchangeRates({
            XAF: d.euroToXAF || 655.957,
          });
        } else {
          console.warn("No FX rates found, using default XAF rate.");
        }
      },
      (err) => console.error("Error fetching FX rates:", err)
    );

    return () => unsubscribe();
  }, []);

  return (
    <CurrencyContext.Provider value={{ currency, exchangeRates }}>
      {children}
    </CurrencyContext.Provider>
  );
};
